'use strict';

var _rollupPluginBabelHelpers = require('../../../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
var PropTypes = require('prop-types');
var classnames = require('classnames');
var index$2 = require('../../atoms/ErrorMessage/index.js');
var index$1 = require('../../atoms/InputText/index.js');
var index = require('../../../hooks/useValidity/index.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);
var classnames__default = /*#__PURE__*/_interopDefaultLegacy(classnames);

var supportedValidationRuleNames = ['required', 'minLength', 'maxLength', 'pattern'];
var validationRuleNamesToValidationReasons = {
  type: 'typeMismatch',
  required: 'valueMissing',
  minLength: 'tooShort',
  maxLength: 'tooLong',
  pattern: 'patternMismatch'
};

var getValidationProps = function getValidationProps(validationRules) {
  return supportedValidationRuleNames.reduce(function (validationProps, supportedValidationRuleName) {
    var validationRule = validationRules[supportedValidationRuleName];
    return !validationRule ? validationProps : _rollupPluginBabelHelpers.objectSpread2({}, validationProps, _rollupPluginBabelHelpers.defineProperty({}, supportedValidationRuleName, validationRule.value));
  }, {});
};

var getValidationErrorReasons = function getValidationErrorReasons(validation) {
  return Object.keys(validation).map(function (validationRuleName) {
    var _ref = validation[validationRuleName] || {},
        errorMessage = _ref.errorMessage;

    return _rollupPluginBabelHelpers.objectSpread2({
      name: validationRuleNamesToValidationReasons[validationRuleName]
    }, errorMessage && {
      message: errorMessage
    });
  });
};

var ValidatingInputText = function ValidatingInputText(_ref2) {
  var type = _ref2.type,
      className = _ref2.className,
      validation = _ref2.validation,
      makeInvalid = _ref2.makeInvalid,
      validationErrorMessage = _ref2.validationErrorMessage,
      inputProps = _ref2.inputProps,
      _onChange = _ref2.onChange;
  var validationErrorReasons = getValidationErrorReasons(validation);

  var _useValidity = index(validationErrorReasons),
      _useValidity2 = _rollupPluginBabelHelpers.slicedToArray(_useValidity, 2),
      _useValidity2$ = _useValidity2[0],
      clientValid = _useValidity2$.valid,
      validityErrorMessage = _useValidity2$.message,
      checkValidity = _useValidity2[1];

  var valid = !makeInvalid && clientValid;
  var errorMessage = makeInvalid ? validationErrorMessage : validityErrorMessage;

  var inputClassName = inputProps.className,
      extraInputProps = _rollupPluginBabelHelpers.objectWithoutProperties(inputProps, ["className"]);

  return /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, /*#__PURE__*/React__default['default'].createElement(index$1, _rollupPluginBabelHelpers.extends({}, extraInputProps, {
    type: type,
    className: classnames__default['default']('ds-mol-validating-input-text-normal', className)
  }, getValidationProps(validation), {
    error: !valid,
    onInvalid: function onInvalid(e) {
      e.preventDefault();
      checkValidity(e);
    },
    onBlur: checkValidity,
    onChange: function onChange(event) {
      _onChange(event);

      if (!valid) {
        checkValidity(event);
      }
    }
  })), !valid && /*#__PURE__*/React__default['default'].createElement(index$2, {
    className: classnames__default['default']('ds-mol-validating-input-text-normal__error-message', className)
  }, errorMessage));
};

var validationPropType = PropTypes__default['default'].shape({
  type: PropTypes__default['default'].shape({
    errorMessage: PropTypes__default['default'].string
  }),
  required: PropTypes__default['default'].shape({
    value: PropTypes__default['default'].bool,
    errorMessage: PropTypes__default['default'].string
  }),
  minLength: PropTypes__default['default'].shape({
    value: PropTypes__default['default'].number,
    errorMessage: PropTypes__default['default'].string
  }),
  maxLength: PropTypes__default['default'].shape({
    value: PropTypes__default['default'].number,
    errorMessage: PropTypes__default['default'].string
  }),
  pattern: PropTypes__default['default'].shape({
    value: PropTypes__default['default'].string,
    errorMessage: PropTypes__default['default'].string
  })
});
ValidatingInputText.propTypes = {
  /**
   * The value to pass to the 'type' attribute of the underlying
   * <input> element. Only the enumerated values are supported.
   */
  type: PropTypes__default['default'].oneOf(['text', 'email', 'tel', 'password']),

  /**
   * A custom CSS class name to attach to both InputText and ErrorMessage
   * child components.
   */
  className: PropTypes__default['default'].string,

  /**
   * An object representing a map between the name of the condition
   * to check for and an object that contains both its value and
   * the error message to show in case it is not satisfied. See the definition
   * of validationPropType for mor detail on what is the expected shape
   * of this object.
   */
  validation: validationPropType,

  /**
   * If true, the component will consider the input value invalid,
   * ignore the rules passed in the `validation` prop and display the error
   * message defined as the value of `validationErrorMessage`
   */
  makeInvalid: PropTypes__default['default'].bool,

  /**
   * The custom error message to display if `makeInvalid` is `true`.
   */
  validationErrorMessage: PropTypes__default['default'].string,

  /**
   * The callback to call every time the underlying <input> element emits the
   * `change` event.
   */
  onChange: PropTypes__default['default'].func,

  /**
   * Additional props to attach to the underlying InputText component. As one may expect,
   * `type`, `required`, `minLength`, `maxLength` and `pattern` will be ignored.
   */
  inputProps: PropTypes__default['default'].object
};
ValidatingInputText.defaultProps = {
  type: 'text',
  className: '',
  validation: {},
  makeInvalid: false,
  validationErrorMessage: '',
  onChange: function onChange() {},
  inputProps: {}
};

module.exports = ValidatingInputText;
